import React, { FC } from 'react';
import styles from './FilterChips.module.scss';
import Icon from '@/components/UI/icon/Icon';
import { IconNames } from '@/components/UI/Types';
import Box from '@/components/UI/box/Box';
import Typography from '@/components/UI/typography/Typography';
interface FilterChipsProps {
  type: 'primary' | 'secondary';
  checked: boolean;
  label: string;
  handleClick: (e: React.MouseEvent<HTMLDivElement>) => void;
  handleClean: (e: React.MouseEvent<HTMLDivElement>) => void;
  startIcon?: IconNames;
  endIcon?: boolean;
  id?: string;
  name?: string;
}
const FilterChips: FC<FilterChipsProps> = ({
  type,
  checked,
  label,
  handleClick,
  handleClean,
  startIcon,
  endIcon,
  id,
  name
}) => {
  const renderIconType = () => {
    if (type === 'primary') {
      return checked ? 'primary' : 'white';
    } else {
      return checked ? 'primary' : 'mediumEmphasis';
    }
  };
  const checkedPrimary = checked ? type === 'primary' ? 'checked-primary' : 'checked-secondary' : '';
  const notChecked = !checked ? type === 'primary' ? 'not-checked-primary' : 'not-checked-secondary' : '';
  const typeStyle = type ? type === 'primary' ? 'primary-type' : 'secondary-type' : '';
  const checkedStyle = checked ? 'checked' : '';
  return <Box className={styles['filter-chips-container'] + ' ' + styles[checkedStyle] + ' ' + styles[checkedPrimary] + ' ' + styles[notChecked] + ' ' + styles[typeStyle]} id={id} data-sentry-element="Box" data-sentry-component="FilterChips" data-sentry-source-file="FilterChips.tsx">
      <Box onClick={handleClick} className={styles['label-section']} data-sentry-element="Box" data-sentry-source-file="FilterChips.tsx">
        {type === 'primary' && !checked && <Box className={styles['pulse']}></Box>}
        {startIcon && <Icon name={startIcon} type={renderIconType()} />}
        <Typography variant="bodyM_Bold" className={styles['label-text']} data-sentry-element="Typography" data-sentry-source-file="FilterChips.tsx">
          {label}
        </Typography>
      </Box>

      {endIcon && !!checked && <Box onClick={handleClean} className={styles['close-icon-section']}>
          <Icon name="close" type={renderIconType()} />
        </Box>}
    </Box>;
};
export default FilterChips;